import { AfterViewInit, Component, ViewEncapsulation, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { PortService } from 'src/app/services/port/port.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-performa-add-port-modal',
  templateUrl: './performa-add-port-modal.component.html',
  styleUrls: ['./performa-add-port-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PerformaAddPortModalComponent extends DestructorComponent implements OnInit, AfterViewInit {

  @Output() portAdded = new EventEmitter<void>();

  countryList: any[] = [];
  isLoading = false;

  formData = {
    country: '',
    portName: ''
  };

  constructor(
    private _globalStateService: GlobalStateService,
    private _portService: PortService
  ) {
    super();
  }

  ngOnInit(): void {
    // Subscribe to countries from GlobalStateService
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe(countries => {
        this.countryList = countries || [];
      })
    );
  }

  ngAfterViewInit(): void {
  }

  onSubmit(form: NgForm): void {
    if (form.invalid) {
      // Show validation errors
      Swal.fire({
        text: "Please fill in all required fields correctly.",
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "Ok, got it!",
        customClass: {
          confirmButton: "btn btn-primary"
        }
      });
      return;
    }

    this.isLoading = true;

    // Prepare data for API
    const submitData = {
      country_code: this.formData.country,
      name: this.formData.portName
    };

    // Call the PortService AddData method
    this.subscriptions.push(
      this._portService.AddData(submitData).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          console.log('Port created successfully:', response);

          // Show success message
          Swal.fire({
            text: "Port has been successfully created!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          }).then((result: any) => {
            if (result.isConfirmed) {
              // Close the modal
              this.closeModal();

              // Emit event to refresh the listing
              this.portAdded.emit();

              // Reset the form
              this.resetForm();
            }
          });
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error creating port:', error);

          // Show error message
          Swal.fire({
            text: error?.error?.message || "An error occurred while creating the port. Please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          });
        }
      })
    );
  }

  closeModal(): void {
    const modalElement = document.getElementById('performa_add_to_from_port_for');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  resetForm(): void {
    this.formData = {
      country: '',
      portName: ''
    };
  }
}
